import { PAYMENT_PERIODS } from '@/utils/stripe/constants'
import { PRODUCT_FAMILY, PRODUCTS } from './authorization'

export const PLAN_DETAILS = {
  [PRODUCTS.ASO_LITE]: {
    description: 'Perfect for individuals starting their ASO journey with essential tools.',
    keyFeatures: [
      '**25** Keywords',
      '**3** Apps & **3** Competitors per App',
      '**3-month long** Historical Data',
      '**1** Seat',
    ],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: 'Keyword Features',
        features: [
          'Limited ranked keywords report',
          'Keyword research tools',
          'AI-powered keyword suggestions',
          'Volume and Difficulty Score',
          'Real-time keyword search and analysis',
        ],
      },
      {
        label: 'Metadata',
        features: [
          'Metadata analysis',
        ],
      },
      {
        label: 'Store Exploration',
        features: [
          'App page preview',
          'App and game taxonomy details',
          'Rating and review analysis',
        ],
      },
      {
        label: 'Help Center and Live Support',
        features: [],
      },
    ],
  },
  [PRODUCTS.ASO_BASIC_V2]: {
    description: 'Perfect for individuals or small teams to grow with deeper competitive insights.',
    keyFeatures: [
      '**500** Keywords',
      '**5** Apps & **5** Competitors per App',
      '**6-month long** Historical Data',
      '**1** Seat',
    ],
    additionalFeaturesHeading: 'Everything in Lite, plus:',
    additionalFeatures: [
      {
        label: 'Keyword Features',
        features: [
          'Advanced keyword grouping',
          'Broader ranked keywords report',
          'Extensive keyword research tools',
          'Competitor keyword insights',
          'Keywords volume trend',
        ],
      },
      {
        label: 'Metadata',
        features: [
          'Competitive metadata analysis',
          'App update timeline',
        ],
      },
      {
        label: 'Store Exploration',
        features: [
          'Featured apps',
          'Advanced App and game taxonomy filtering',
          'Review sentiment analysis',
        ],
      },
    ],
  },
  [PRODUCTS.ASO_PRO]: {
    description: 'Ideal for teams looking to discover more growth opportunities.',
    keyFeatures: [
      '**1500** Keywords',
      '**8** Apps & **8** Competitors per App',
      '**12-month long** Historical Data',
      '**3** Seats',
    ],
    additionalFeaturesHeading: 'Everything in Basic, plus:',
    additionalFeatures: [
      {
        label: 'Keyword Features',
        features: [
          'More in ranked keywords report',
          'Brand vs generic keywords',
          'Organic downloads per keyword',
          'Keyword trends',
          'Metadata optimization tool',
        ],
      },
      {
        label: 'Store Exploration',
        features: [
          'Product page creative explorer',
          'Similar apps',
          'In-app events',
          'Promotional content',
        ],
      },
      {
        label: 'Localization',
        features: [
          'Localization performance report',
          'Keyword translator',
        ],
      },
    ],
  },
  [PRODUCTS.ASO_BUSINESS]: {
    description: 'Built for organizations seeking a complete app marketing solution.',
    keyFeatures: [
      '**Flexible** Keywords',
      '**20** Apps & **Unlimited** Competitors',
      '**Unlimited** Historical Data',
      '**Unlimited** Seat',
    ],
    additionalFeaturesHeading: 'Everything in Pro, plus:',
    additionalFeatures: [
      {
        label: 'Keyword Features',
        features: [
          'All ranked keywords report',
          'Movement analysis of ranked keywords',
          'Worldwide visibility report of app',
        ],
      },
      {
        label: 'CPP Intelligence',
        features: [
          'Custom product page explorer',
        ],
      },
      {
        label: 'Ad Intelligence',
        features: [
          'Ad creative insights in +40 ad networks',
        ],
      },
      {
        label: 'Search Ads Intelligence',
        features: [
          'Paid keyword insights',
          'Impression share analysis',
          'Ad placement analysis',
        ],
      },
      {
        label: 'Support and Resources',
        features: [
          'Dedicated customer success manager',
          'Single Sign-On (SSO) Feature',
        ],
      },
    ],
  },
  [PRODUCTS.ASA_FREEMIUM]: {
    description: 'For Apple Search Ads marketers just getting started.',
    keyFeatures: [
      '**Unlimited** Ad Spend',
      '**Unlimited** Data Retention',
      '**1** Seat',
    ],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: '9 Essential Tools',
      },
      {
        label: 'Campaign Management',
        features: [
          'Full funnel view',
          'Performance overview',
          'Advanced Ads Manager',
          'AI-powered keyword suggestions',
          'Volume and Difficulty Score',
          'Customer journey visualization',
        ],
      },
      {
        label: 'Co-Pilot',
        features: [
          'Strategic recommendations',
          'Quick campaign setup',
          'Quick campaign optimization',
        ],
      },
      {
        label: 'Mobile Measurement Partner',
        features: [
          'Integrations',
          'Creating optimization goals',
        ],
      },
      {
        label: 'Help Center and Live Support',
        features: [],
      },
    ],
  },
  [PRODUCTS.SEARCH_ADS]: {
    description: 'Ideal for companies looking for a comprehensive market intelligence solution.',
    keyFeatures: [
      '**Unlimited** Ad Spend',
      '**Unlimited** Data Retention',
      '**Unlimited** Seats',
    ],
    additionalFeaturesHeading: 'Everything in Free, plus:',
    additionalFeatures: [
      {
        label: 'Campaign Management',
        features: [
          'Multi-layered automations',
          '20+ automation templates',
          'Advanced Ads Manager',
          'Full Ads Manager capabilities',
        ],
      },
      {
        label: 'Co-Pilot',
        features: [
          'Smart Bidding',
          'Budget Allocation',
          'Paid keyword identification',
        ],
      },
      {
        label: 'Competitive Insights',
        features: [
          'Competitive intelligence',
          'CPP intelligence',
          'Category benchmarks',
          'Strategic performance forecasting',
          'Keyword recommendations',
          'Organic keyword suggestions',
        ],
      },
      {
        label: 'Support and Resources',
        features: [
          'Dedicated customer success manager',
          'Expert onboarding and training sessions',
          'Automated Slack + Email notifications',
        ],
      },
    ],
  },
  [PRODUCTS.MARKET_PRO]: {
    description: 'Perfect for individual small teams seeking robust market intelligence.',
    keyFeatures: [],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: '',
        features: [
          '**2 seats**',
          'Access to 12 months of historical data',
          'Revenue and download estimates for apps and games',
          'Market size analysis',
          'In-depth market trends monitoring',
          'Identification of top-performing apps',
          'Competitor app analysis',
          'Publisher analysis',
        ],
      },
    ],
  },
  [PRODUCTS.MARKET_ENTERPRISE]: {
    description: 'Ideal for companies looking for a comprehensive market intelligence solution.',
    keyFeatures: [],
    additionalFeaturesHeading: 'Everything in Pro, plus:',
    additionalFeatures: [
      {
        label: '',
        features: [
          '**10 seats**',
          'Unlimited access to historical data',
          'Comprehensive app and game taxonomy',
          'Onboarding and training with an expert',
          'A dedicated customer success manager',
          'Single Sign-On (SSO) for seamless and secure access',
        ],
      },
    ],
  },
  [PRODUCTS.SA_INTEL_ENTERPRISE]: {
    description: 'Find high-converting paid keywords for Apple Search Ads campaigns.',
    keyFeatures: [],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: 'Insights on all ad placements',
        features: [],
      },
      {
        label: 'Keyword Analysis',
        features: [
          'Keyword impression data',
          'Keyword trends and opportunities',
          'Paid user acquisition overview',
        ],
      },
      {
        label: 'App Analysis',
        features: [
          'App performance for paid keywords',
          'Tracking apps with ad visibility',
        ],
      },
      {
        label: 'Competitor Analysis',
        features: [
          'Ad placement analysis',
          'Competitor keyword discovery',
          'Top advertisers by country and storefront',
        ],
      },
      {
        label: 'Support and Resources',
        features: [
          'Dedicated customer success manager',
          'Expert onboarding and training sessions',
          'Help center and Intercom support',
        ],
      },
    ],
  },
  [PRODUCTS.CPP_INTEL_ENTERPRISE]: {
    description: 'Optimize custom product pages without A/B testing.',
    keyFeatures: [],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: 'Custom Product Pages by Apps',
        features: [
          'Finding custom product pages of any app',
          'Performance snapshot and metrics',
          'Default page comparison',
        ],
      },
      {
        label: 'Custom Product Pages by Keywords',
        features: [
          'Impression share overview by keyword and country',
          'Keyword-centric analysis',
          'Timing and impression share correlation',
        ],
      },
      {
        label: 'Custom Product Pages by Competitors',
        features: [
          'Competitor custom product pages',
          'Data on top-performing apps',
          'Seasonality analysis',
        ],
      },
      {
        label: 'Custom Product Pages by Ad Networks',
        features: [
          'Custom product pages across ad networks and countries',
        ],
      },
      {
        label: 'Support and Resources',
        features: [
          'Dedicated Customer Success Manager',
          'Expert onboarding and training sessions',
          'Help center and Intercom support',
        ],
      },
    ],
  },
  [PRODUCTS.AD_INTEL_ENTERPRISE]: {
    description: 'Understand the ad creative best practices in any category.',
    keyFeatures: [],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: 'Ad Analysis',
        features: [
          'Creative data on 90M+ ad creatives',
          'Advanced filters for a detailed research',
          'Competitors’ ad creative data',
          'Creative data across 10+countries',
          'Data on 55+ ad networks and DSPs',
        ],
      },
      {
        label: 'Top Charts',
        features: [
          'Leading developers categorized by platform and category',
          'Top players in paid user acquisition and publishing',
          'List of most engaging creatives for user interaction',
        ],
      },
      {
        label: 'Collections',
        features: [
          'App collections capability for streamlining research',
          'Creative collection capability for building inspiration boards',
        ],
      },
      {
        label: 'Support and Resources',
        features: [
          'Dedicated Customer Success Manager',
          'Expert onboarding and training sessions',
          'Help center and Intercom support',
        ],
      },
    ],
  },
  API_SOLUTIONS: {
    description: 'Unlock your potential with custom API solutions.',
    keyFeatures: [],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: '80+ API Datapoints',
      },
      {
        label: 'Apple Search Ads Insights',
        features: [
          'Apps bidding on specific keywords',
          'Keyword performance data',
        ],
      },
      {
        label: 'Detailed SearchAds.com Integration',
        features: [
          'Campaign data',
          'Bid history logs',
          'Performance reports',
        ],
      },
      {
        label: 'Custom Goals Integration',
        features: [
          'Custom goal data accessible with IDs on SearchAds.com',
        ],
      },
      {
        label: 'Custom Dashboards',
        features: [
          'Dashboards for paid activities using campaign management insights',
          'Dashboards for organic activities using app store and intelligence data',
        ],
      },
      {
        label: 'Comprehensive App Store Data',
        features: [
          'App Store data on 2M keywords',
          'Google Play Store data on 2M+ keywords',
        ],
      },
      {
        label: 'Advanced Metric Access',
        features: [
          'Daily keyword rankings',
        ],
      },
      {
        label: 'Ad Creative Analysis',
        features: [
          'Leading developers categorized by platform and category',
          'Top players in paid user acquisition and publishing',
          'List of most engaging creatives for user interaction',
        ],
      },
      {
        label: 'Support and Resources',
        features: [
          'Dedicated Customer Success Manager',
          'Expert onboarding and training sessions',
          'Help center and Intercom support',
        ],
      },
    ],
  },
  ASO_SERVICES: {
    description: 'Climb the charts on the App Store and Google Play Store with expert support.',
    keyFeatures: [],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: 'Analysis and Management',
        features: [
          'Account health check',
          'Market and trend monitoring',
          'Competitive analysis',
          'Strategy building powered by science',
          'Regular online meetings',
          'Always on Slack and email support',
        ],
      },
      {
        label: 'Visibility Optimization',
        features: [
          'Continuous keyword optimization',
          'Continuous metadata refinement',
          'Store structure for geos & search terms',
        ],
      },
      {
        label: 'Conversion Optimization',
        features: [
          'Regular A/B tests',
          'Icon, screenshot and video production',
          'Store structure for geos & search terms',
        ],
      },
      {
        label: 'Engagement Optimization',
        features: [
          'Sentiment and review monitoring',
          'User feedback',
          'Store structure for geos & search terms',
          'In-app events optimization',
          'Promotional content optimization',
        ],
      },
      {
        label: 'Help Center and Live Support',
        features: [],
      },
    ],
  },
  ASA_SERVICES: {
    description: 'Build, optimize and manage Apple Search Ads campaigns for your KPIs.',
    keyFeatures: [],
    additionalFeaturesHeading: 'Includes:',
    additionalFeatures: [
      {
        label: 'Analysis and Management',
        features: [
          'Account health check',
          'App and market analysis',
          'Competitive analysis',
          'Strategy development for key markets',
          'Budget distribution',
          'Technical configurations of MMP and SearchAds.com',
        ],
      },
      {
        label: 'Launch',
        features: [
          'Proper account structuring',
          'Campaign setup',
          'KPI identification',
          'Launch of campaigns',
        ],
      },
      {
        label: 'Reporting',
        features: [
          'Market and trend monitoring',
          'Competitive analysis',
          'Regular online meetings',
          'Daily monitoring',
          'Always on Slack and email support',
          'View access to SearchAds.com',
        ],
      },
      {
        label: 'Optimization',
        features: [
          'Continuous optimization of campaign elements',
          'Testing key markets to maintain KPIs',
          'Scaling strategies for new markets',
          'Hypothesis and testing for custom product pages',
        ],
      },
      {
        label: 'Help Center and Live Support',
        features: [],
      },
    ],
  },
}

export const PRODUCT_PLANS = {
  [PRODUCTS.ASO_LITE]: {
    slug: 'lite',
    label: 'Lite',
    productLabel: 'ASO',
    stripeProductId: PRODUCTS.ASO_LITE,
    upgradableStripeProductIds: [PRODUCTS.ASO_BASIC_V2, PRODUCTS.ASO_PRO],
    isTrialStartable: true,
    trialDays: 7,
    historicalDataMonthCount: 3,
    seatCount: 1,
    isEnterprise: false,
    highlighted: false,
    priceOptions: [
      {
        id: PAYMENT_PERIODS.MONTHLY,
        amount: 15,
        description: 'per month\n\nbilled monthly',
      },
      {
        id: PAYMENT_PERIODS.YEARLY,
        amount: 12.5,
        description: 'per month\n\nbilled yearly',
      },
    ],
  },
  [PRODUCTS.ASO_BASIC_V2]: {
    slug: 'basic',
    label: 'Basic',
    productLabel: 'ASO',
    stripeProductId: PRODUCTS.ASO_BASIC_V2,
    upgradableStripeProductIds: [PRODUCTS.ASO_PRO],
    isTrialStartable: true,
    trialDays: 7,
    historicalDataMonthCount: 6,
    seatCount: 1,
    isEnterprise: false,
    highlighted: true,
    priceOptions: [
      {
        id: PAYMENT_PERIODS.MONTHLY,
        amount: 69,
        description: 'per month\n\nbilled monthly',
      },
      {
        id: PAYMENT_PERIODS.YEARLY,
        amount: 59,
        description: 'per month\n\nbilled yearly',
      },
    ],
  },
  [PRODUCTS.ASO_PRO]: {
    slug: 'pro',
    label: 'Pro',
    productLabel: 'ASO',
    stripeProductId: PRODUCTS.ASO_PRO,
    upgradableStripeProductIds: null,
    isTrialStartable: true,
    trialDays: 7,
    historicalDataMonthCount: 12,
    seatCount: 3,
    isEnterprise: false,
    highlighted: false,
    priceOptions: [
      {
        id: PAYMENT_PERIODS.MONTHLY,
        amount: 239,
        description: 'per month\n\nbilled monthly',
      },
      {
        id: PAYMENT_PERIODS.YEARLY,
        amount: 199,
        description: 'per month\n\nbilled yearly',
      },
    ],
  },
  [PRODUCTS.ASO_BUSINESS]: {
    slug: 'enterprise',
    label: 'Enterprise',
    productLabel: 'ASO',
    stripeProductId: PRODUCTS.ASO_BUSINESS,
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: false,
    priceOptions: [],
  },
  [PRODUCTS.ASA_FREEMIUM]: {
    slug: 'freemium',
    label: 'Freemium',
    productLabel: 'ASA',
    stripeProductId: PRODUCTS.ASA_FREEMIUM,
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: false,
    highlighted: false,
    priceOptions: [
      {
        id: PAYMENT_PERIODS.FREE,
        amount: 0,
        description: 'upgrade anytime',
      },
    ],
  },
  [PRODUCTS.SEARCH_ADS]: {
    slug: 'enterprise',
    label: 'Enterprise',
    productLabel: 'ASA',
    stripeProductId: PRODUCTS.SEARCH_ADS,
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: true,
    priceOptions: [],
  },
  [PRODUCTS.MARKET_PRO]: {
    slug: 'pro',
    label: 'Pro',
    productLabel: 'Market Intelligence',
    stripeProductId: PRODUCTS.MARKET_PRO,
    upgradableStripeProductIds: null,
    isTrialStartable: true,
    trialDays: 3,
    isEnterprise: false,
    highlighted: true,
    priceOptions: [
      {
        id: PAYMENT_PERIODS.MONTHLY,
        amount: 999,
        description: 'per month\n\nbilled monthly',
      },
      {
        id: PAYMENT_PERIODS.YEARLY,
        amount: 833,
        description: 'per month\n\nbilled yearly',
      },
    ],
  },
  [PRODUCTS.MARKET_ENTERPRISE]: {
    slug: 'enterprise',
    label: 'Enterprise',
    productLabel: 'Market Intelligence',
    stripeProductId: PRODUCTS.MARKET_ENTERPRISE,
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: false,
    priceOptions: [],
  },
  [PRODUCTS.SA_INTEL_ENTERPRISE]: {
    slug: 'search-ads-intelligence',
    label: 'Search Ads Intelligence',
    productLabel: 'Search Ads Intelligence',
    stripeProductId: PRODUCTS.SA_INTEL_ENTERPRISE,
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: false,
    priceOptions: [],
  },
  [PRODUCTS.CPP_INTEL_ENTERPRISE]: {
    slug: 'cpp-intelligence',
    label: 'CPP Intelligence',
    stripeProductId: PRODUCTS.CPP_INTEL_ENTERPRISE,
    upgradableStripeProductIds: null,
    productLabel: 'Search Ads Intelligence',
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: false,
    priceOptions: [],
  },
  [PRODUCTS.AD_INTEL_ENTERPRISE]: {
    slug: 'ad-intelligence',
    label: 'Ad Intelligence',
    productLabel: 'Ad Creative Intelligence',
    stripeProductId: PRODUCTS.AD_INTEL_ENTERPRISE,
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: false,
    priceOptions: [],
  },
  API_SOLUTIONS: {
    slug: 'api-solutions',
    label: 'API Solutions',
    productLabel: 'API',
    stripeProductId: 'API_SOLUTIONS',
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: false,
    priceOptions: [],
  },
  ASO_SERVICES: {
    slug: 'aso-services',
    label: 'ASO Services',
    productLabel: 'Managed Services',
    stripeProductId: 'ASO_SERVICES',
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: false,
    priceOptions: [],
  },
  ASA_SERVICES: {
    slug: 'apple-search-ads-services',
    label: 'Apple Search Ads Services',
    productLabel: 'Managed Services',
    stripeProductId: 'ASA_SERVICES',
    upgradableStripeProductIds: null,
    isTrialStartable: false,
    trialDays: 0,
    isEnterprise: true,
    highlighted: false,
    priceOptions: [],
  },
}

export const PRODUCT_FAMILIES = [
  {
    slug: 'app-store-optimization',
    label: 'App Store Optimization',
    productKey: PRODUCT_FAMILY.ASO,
    packages: [
      PRODUCT_PLANS[PRODUCTS.ASO_LITE],
      PRODUCT_PLANS[PRODUCTS.ASO_BASIC_V2],
      PRODUCT_PLANS[PRODUCTS.ASO_PRO],
      PRODUCT_PLANS[PRODUCTS.ASO_BUSINESS],
    ],
  },
  {
    slug: 'apple-search-ads-manager',
    label: 'Apple Search Ads Manager',
    productKey: PRODUCT_FAMILY.SEARCH_ADS,
    packages: [
      PRODUCT_PLANS[PRODUCTS.ASA_FREEMIUM],
      PRODUCT_PLANS[PRODUCTS.SEARCH_ADS],
    ],
  },
  {
    slug: 'market-intelligence',
    label: 'Market Intelligence',
    productKey: PRODUCT_FAMILY.MARKET,
    packages: [
      PRODUCT_PLANS[PRODUCTS.MARKET_PRO],
      PRODUCT_PLANS[PRODUCTS.MARKET_ENTERPRISE],
    ],
  },
  {
    slug: 'search-ads-intelligence',
    label: 'Search Ads Intelligence',
    productKey: PRODUCT_FAMILY.SA_INTEL,
    packages: [
      PRODUCT_PLANS[PRODUCTS.SA_INTEL_ENTERPRISE],
      PRODUCT_PLANS[PRODUCTS.CPP_INTEL_ENTERPRISE],
    ],
  },
  {
    slug: 'ad-creative-intelligence',
    label: 'Ad Creative Intelligence',
    productKey: PRODUCT_FAMILY.AD_INTEL,
    packages: [
      PRODUCT_PLANS[PRODUCTS.AD_INTEL_ENTERPRISE],
    ],
  },
  {
    slug: 'api',
    label: 'API',
    productKey: 'API',
    packages: [
      PRODUCT_PLANS.API_SOLUTIONS,
    ],
  },
  {
    slug: 'managed-services',
    label: 'Managed Services',
    productKey: 'ASO_SERVICES',
    packages: [
      PRODUCT_PLANS.ASO_SERVICES,
      PRODUCT_PLANS.ASA_SERVICES,
    ],
  },
]
